// Props
type DashboardCardProps = {
  title?: string;
  extra?: string;
  bgColor?:
  | "white"
  | "50"
  | "100"
  | "200"
  | "300"
  | "400"
  | "500"
  | "600"
  | "700"
  | "800"
  | "900";
textColor?:
  | "primary"
  | "secondary"
  | "tertiary"
  | "white"
  children?: React.ReactNode;
  topRight?: React.ReactNode;
};

const DashboardCard = ({
  title,
  extra,
  textColor = "primary",
  bgColor = "900",
  children,
  topRight,
}: DashboardCardProps) => {
  // Map semantic color names to Tailwind classes
  const getTextColorClass = (color: string) => {
    switch (color) {
      case "primary":
        return "text-primary";
      case "secondary":
        return "text-secondary";
      case "tertiary":
        return "text-tertiary";
      case "white":
        return "text-white";
      default:
        return `text-text-${color}`;
    }
  };
  return (
    <div
      className={`!z-5 relative flex w-full h-full flex-col rounded-[15px] p-4 md:p-4 md:px-6 ${`bg-background-${bgColor}`} ${getTextColorClass(textColor)} ${extra}`}
    >
      <div className="mb-2 flex w-full flex-col">
        <div className="flex w-full flex-row justify-between gap-2">
          <div className="flex flex-col truncate">
            <div className={`heading-md`}>{title}</div>
          </div>

          <div className="">{topRight}</div>
        </div>
      </div>

      {children}
    </div>
  );
};

export default DashboardCard;
